import { render } from "./wx_imgText_add.vue?vue&type=template&id=0d1c5ebc"
import script from "./wx_imgText_add.vue?vue&type=script&lang=js"
export * from "./wx_imgText_add.vue?vue&type=script&lang=js"

import "./wx_imgText_add.vue?vue&type=style&index=0&id=0d1c5ebc&lang=less"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__